var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:[
    'bb-file-list',
    _vm.version && _vm.currentFiles.length && ("bb-file-list_" + _vm.version)
  ]},_vm._l((_vm.currentFiles),function(item){return _c('div',{key:item.id,class:[
      'bb-file-list-item',
      _vm.version && ("bb-file-list-item_" + _vm.version)
    ]},[_c('div',{staticClass:"bb-file-list-item__icon"},[_c('div',{domProps:{"innerHTML":_vm._s(_vm.fileIcon)}})]),_vm._v(" "),_c('div',[_c('div',{staticClass:"bb-file-list-item__name"},[_vm._v("\n          "+_vm._s(item.label)+"\n          "),_c('div',{class:[
              'bb-file-list-item__close',
              _vm.version && ("bb-file-list-item__close_" + _vm.version)
            ],domProps:{"innerHTML":_vm._s(_vm.closeIcon)},on:{"click":function($event){return _vm.onDeleteFile(item)}}})]),_vm._v(" "),(item.fileSize)?_c('div',{staticClass:"bb-file-list-item__name bb-file-list-item__size"},[_vm._v("\n          "+_vm._s(item.fileSize)+"\n        ")]):_vm._e()])])}),0)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-9435702a","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Main/BBForm/BBFile/BBFileListDefault.vue
// module id = null
// module chunks = 